/**
 * Main-thread KaTeX hydration step. Walks a hast tree and replaces the
 * MathML/HTML math spans emitted by `remark-math` with KaTeX markup. Pure
 * data transform once the module is loaded, but module-init touches
 * `document` (KaTeX builds a probe `<i>` element for font-feature
 * detection at top level), so this MUST be imported from the main thread —
 * the worker uses `renderForWorker` from `./trustedNoKatex`, which omits
 * KaTeX, and the client (`@slate/ui/perf/pipelineClient`) calls
 * `applyKatex` on the returned hast.
 */
import { unified, type Processor } from 'unified';
import rehypeKatex from 'rehype-katex';
import type { Root as HastRoot } from 'hast';

let processor: Processor<HastRoot, HastRoot, HastRoot, undefined, undefined> | null = null;

export function applyKatex(tree: HastRoot): HastRoot {
  if (!processor) {
    processor = unified().use(rehypeKatex, { trust: false, strict: false }) as unknown as Processor<
      HastRoot,
      HastRoot,
      HastRoot,
      undefined,
      undefined
    >;
  }
  return processor.runSync(tree) as HastRoot;
}
